var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cookies-policy"},[_c('div',{staticClass:"cookies-policy__wrapper"},[_c('div',{staticClass:"cookies-policy__content"},[_c('vue-markdown',[_vm._v("\n        "+_vm._s(_vm.content)+"\n      ")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }